import * as types from '../types';
import * as userApi from '../api/user';
import * as api from '../api/index';
import axios from 'axios';
import { isFlowBaseAnnotation } from 'babel-types';

export const state = () => {
  return {
    loginInfo: null,
    isLoginFormShow: false,
    isRegistFirst: true,
    followList: {},
    isLogin: false,
    focusList: {},
    stockFocusList: {},
    stockNum: 0, //自选股数量
    followingNum: 0, //关注数量
    publishNum: 0 //发表数量
  };
};

// userInfo结构如下
// "user": {
//   "userId": 175959,
//   "nickname": "zllll",
//   "avatar": "http://img4.gelonghui.com/headdefault/avatar_default2.png",
//   "sex": null,
//   "createDate": 1541989917,
//   "userBrief": null,
//   "state": null,
//   "city": null,
//   "birth": null,
//   "country": "中国",
//   "userType": 0,
//   "email": null,
//   "countryCode": "86",
//   "phone": "13068714875",
//   "inviteCode": "A6J8OG"
// }
export const getters = {
  userInfo: state => {
    return state.loginInfo ? state.loginInfo.user : null;
  },
  isLogin: state => {
    return state.isLogin;
  },
  avatar: (state, getters) => {
    return getters.userInfo ? getters.userInfo.avatar : '';
  },
  userId: (state, getters) => {
    return getters.userInfo ? getters.userInfo.userId : '';
  },
  roleList: state => {
    return state.loginInfo ? state.loginInfo.roleList : '';
  },
  isFollow: state => {
    return id => {
      return state.followList[id] === true;
    };
  },
  isFocusStock: state => {
    return id => {
      return state.stockFocusList[id] === true;
    };
  },
  userBrief: (state, getters) => {
    return getters.userInfo ? getters.userInfo.userBrief : '';
  },
  nickname: (state, getters) => {
    return getters.userInfo ? getters.userInfo.nickname : '';
  },
  followerCnt: state => {
    return state.loginInfo ? state.loginInfo.fanNum : 0;
  },
  followingCnt: state => {
    return state.loginInfo ? state.followingNum : 0;
  },
  favCnt: state => {
    return state.loginInfo ? state.loginInfo.favNum : 0;
  },
  postCnt: state => {
    return state.loginInfo ? state.publishNum : 0;
  },
  stockCnt: state => {
    return state.loginInfo ? state.stockNum : 0;
  },
  // isFocus: (state) => {
  //   return (id) => {
  //     return state.focusList[id] === true;
  //   }
  // }
  vipInfo: state => {
    return state.loginInfo
      ? {
          vipType: state.loginInfo.vipType,
          vipIsTrial: state.loginInfo.vipIsTrial,
          vipExpireTimestamp: state.loginInfo.vipExpireTimestamp
        }
      : {
          vipType: '',
          vipIsTrial: '',
          vipExpireTimestamp: null
        };
  }
};

export const mutations = {
  [types.USER_SIGNIN](state, data) {
    localStorage.setItem('user', JSON.stringify(data));
    localStorage.setItem('accessToken', JSON.stringify(data));
    sessionStorage.setItem('user', JSON.stringify(data));
    sessionStorage.setItem('accessToken', JSON.stringify(data));
    let loginInfo = JSON.parse(localStorage.getItem('user'));
    state.loginInfo = loginInfo;
    state.isLogin = true;
    // console.log(state.loginInfo)
  },
  [types.USER_ISLOGIN](state, isLogin) {
    state.isLogin = isLogin;
  },
  [types.USER_SIGNOUT](state) {
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('accessToken');
    state.loginInfo = null;
    state.roleList = '';
    state.isLogin = false;
    // 清空用户其他相关数据
    state.followList = {};
    state.focusList = {};
    state.stockFocusList = {};
  },
  [types.HIDE_LOGIN_FORM](state) {
    state.isRegistFirst = false;
    state.isLoginFormShow = false;
  },
  [types.SHOW_LOGIN_FORM](state, isRegistFirst) {
    state.isRegistFirst = isRegistFirst || false;
    state.isLoginFormShow = true;
  },
  // 传入一个只有关注用户id的数组
  [types.UPDATE_FOLLOWS](state, ids) {
    const newVal = {};
    ids.forEach(id => {
      newVal[id] = true;
    });
    state.followList = newVal;
  },
  [types.FOLLOW](state, id) {
    const newVal = {};
    for (let uid in state.followList) {
      newVal[uid] = true;
    }
    newVal[id] = true;
    state.followList = newVal;
  },
  [types.UNFOLLOW](state, id) {
    const newVal = {};
    for (let uid in state.followList) {
      if (parseInt(uid) !== id) {
        newVal[uid] = true;
      }
    }
    state.followList = newVal;
  },
  [types.STOCKFOCUS](state, id) {
    const newVal = {};
    for (let stockid in state.stockFocusList) {
      newVal[stockid] = true;
    }
    newVal[id] = true;
    state.stockFocusList = newVal;
  },
  [types.UNSTOCKFOCUS](state, id) {
    const newVal = {};
    for (let stockid in state.stockFocusList) {
      if (stockid !== id) {
        newVal[stockid] = true;
      }
    }
    state.stockFocusList = newVal;
  },
  [types.UPDATE_USER_INFO](state, user) {
    console.log(state.loginInfo, user);
    const newLoginInfo = Object.assign({}, state.loginInfo);
    Object.assign(newLoginInfo, {
      user
    });
    state.loginInfo = newLoginInfo;
    this.commit(`user/${types.USER_SIGNIN}`, newLoginInfo);
  },
  // 主题关注列表
  [types.UPDATE_FOCUS](state, ids) {
    const subjectVal = {};
    ids.forEach(id => {
      subjectVal[id] = true;
    });
    state.focusList = subjectVal;
  },
  [types.FOCUS](state, id) {
    const subjectVal = {};
    for (let uid in state.focusList) {
      subjectVal[uid] = true;
    }
    subjectVal[id] = true;
    state.focusList = subjectVal;
  },
  [types.UNFOCUS](state, id) {
    const subjectVal = {};
    for (let uid in state.focusList) {
      if (parseInt(uid) !== id) {
        subjectVal[uid] = true;
      }
    }
    state.focusList = subjectVal;
  },
  // 得到一个用户关注了的股票id列表
  [types.UPDATE_STOCK_FOCUS](state, ids) {
    const newVal = {};
    ids.forEach(id => {
      newVal[id] = true;
    });
    state.stockFocusList = newVal;
  },

  //更新用户自选股总数
  [types.UPDATE_STOCK_COUNT](state, count) {
    state.stockNum = count;
  },
  //获取用户关注数量
  [types.UPDATE_FOLLOWING_COUNT](state, count) {
    state.followingNum = count;
  },
  //更新发表数量
  [types.UPDATE_PUBLISH_COUNT](state, count) {
    state.publishNum = count;
  }
};

export const actions = {
  [types.LOGIN_LOCAL]({ commit, dispatch }) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user === null) {
      return;
    }
    axios(userApi.getLoginStatus())
      .then(res => {
        if (res.data.statusCode === 200) {
          commit(types.USER_SIGNIN, user);
          // 登录成功时获取关注列表
          dispatch(types.GET_FOLLOWS);
          //登录成功时获取主题列表
          dispatch(types.GET_FOCUS);
          // 登陆成功时获取股票关注列表
          setTimeout(() => {
            // 登陆有延迟
            dispatch(types.GET_STOCK_FOCUS);
          }, 500);
          //登陆成功时获取用户info 和粉丝数关注数股票数发表数--wym
          dispatch(types.GET_USER_COUNT);
        } else {
          commit(types.USER_SIGNOUT);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  [types.LOGOUT]({ commit, dispatch }) {
    axios(userApi.loginOut())
      .then(res => {
        if (res.data.statusCode === 200) {
          commit(types.USER_SIGNOUT);
        } else {
          commit(types.USER_SIGNOUT);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  [types.GET_FOLLOWS]({ commit, getters }) {
    axios(
      userApi.getFollowings({
        id: getters.userId,
        page: 1,
        count: 500
      })
    )
      .then(res => {
        if (res.data.statusCode === 200) {
          const ids = res.data.result
            ? res.data.result.map(user => {
                return user.userId;
              })
            : [];
          commit(types.UPDATE_FOLLOWS, ids);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  [types.GET_FOCUS]({ commit, getters }) {
    axios(
      userApi.getFocus({
        userId: getters.userId,
        page: 1
      })
    )
      .then(res => {
        if (res.data.statusCode === 200) {
          const ids = res.data.result
            ? res.data.result.map(item => {
                return item.subjectId;
              })
            : [];
          commit(types.UPDATE_FOCUS, ids);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  [types.GET_STOCK_FOCUS]({ commit, getters }) {
    axios(userApi.getMyStock({})).then(res => {
      if (res.data.statusCode === 200) {
        const ids = res.data.result
          ? res.data.result.map(stock => {
              return stock[1].toLowerCase() + stock[0];
            })
          : [];
        commit(types.UPDATE_STOCK_FOCUS, ids);
      }
    });
  },
  //获取用户info和粉丝数，关注数，发表数 ， 股票数  --wym
  [types.GET_USER_COUNT]({ commit, getters }) {
    axios(
      api.getUserInfo({
        userId: getters.userId
      })
    )
      .then(res => {
        if (res.data.statusCode === 200) {
          const user = res.data.result;
          commit(types.USER_SIGNIN, user);
          const count = {};
          count.stockNum = res.data.result.userStockNum; //股票数
          count.followingNum = res.data.result.followNum; //关注数
          count.publishNum = res.data.result.postNum; //发表数
          // console.log(res.result)问题是res.result里面postNum是0，怎么解决这个？
          commit(types.UPDATE_STOCK_COUNT, count.stockNum);
          commit(types.UPDATE_FOLLOWING_COUNT, count.followingNum);
          commit(types.UPDATE_PUBLISH_COUNT, count.publishNum);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
  //获取用户关注数量
  // [types.UPDATE_FOLLOWING_COUNT]({
  //   commit
  // }, count) {
  //   commit(types.GET_FOLLOWING_COUNT, count)
  // }
};
